import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../api/api";
import Layout from "../components/Layout";

export default function SetupInterview({ onNext, onBack, isWizard = false }) {
  const { id: interviewIdParam } = useParams();
  const navigate = useNavigate();

  const interviewId = parseInt(interviewIdParam, 10);

  const [metadata, setMetadata] = useState({
    title: "",
    description: "",
    welcomeMessage: "",
    logoUrl: "",
    primaryColor: "#000000",
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (isNaN(interviewId)) {
      console.error("Invalid interview ID from URL:", interviewIdParam);
      setError("❌ Invalid interview ID. Please check the URL.");
      setLoading(false);
      return;
    }

    const fetchMetadata = async () => {
      try {
        const res = await api.get(`/interviews/${interviewId}`);
        const data = res.data || {};
        setMetadata({
          title: data.title || "",
          description: data.description || "",
          welcomeMessage: data.welcomeMessage || "",
          logoUrl: data.logoUrl || "",
          primaryColor: data.primaryColor || "#000000",
        });
      } catch (err) {
        console.error("Error fetching interview metadata:", err);
        setError("Failed to load interview metadata. Please try again.");
      } finally {
        setLoading(false);
      }
    };

    fetchMetadata();
  }, [interviewId, interviewIdParam]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setMetadata((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);

    try {
      await api.put(`/interviews/${interviewId}`, metadata);
      console.log(metadata)
      console.info("Metadata saved successfully!");
      if (isWizard && onNext) {
        onNext();
      } else {
        navigate(`/interviews/${interviewId}/questions`);
      }
    } catch (err) {
      console.error("Failed to save metadata:", err);
      setError("❌ Failed to save. Please check your network or try again.");
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <Layout>
        <div className="flex items-center justify-center h-48">
          <span className="text-gray-500">Loading interview details…</span>
        </div>
      </Layout>
    );
  }

  if (error) {
    return (
      <Layout>
        <div className="p-4 bg-red-50 border border-red-200 rounded text-red-700">
          {error}
        </div>
        <button
          onClick={() => navigate("/interviews")}
          className="mt-4 btn-secondary"
        >
          ← Back to Interviews
        </button>
      </Layout>
    );
  }

  return (
    <Layout>
      <h2 className="text-2xl font-bold mb-4">Step 1: Setup Interview Metadata</h2>

      <form onSubmit={handleSubmit} className="space-y-4">
        <input
          name="title"
          placeholder="Interview Title"
          value={metadata.title}
          onChange={handleChange}
          required
          className="input"
        />
        <textarea
          name="description"
          placeholder="Interview Description"
          value={metadata.description}
          onChange={handleChange}
          rows="3"
          className="textarea"
        />
        <textarea
          name="welcomeMessage"
          placeholder="Welcome Message"
          value={metadata.welcomeMessage}
          onChange={handleChange}
          rows="2"
          className="textarea"
        />
        <input
          name="logoUrl"
          placeholder="Logo URL"
          value={metadata.logoUrl}
          onChange={handleChange}
          className="input"
        />
        <label className="block">
          Primary Color:
          <input
            type="color"
            name="primaryColor"
            value={metadata.primaryColor}
            onChange={handleChange}
            className="ml-2"
          />
        </label>

        <div className="flex justify-between mt-6">
          {isWizard && onBack && (
            <button
              type="button"
              onClick={onBack}
              className="btn-secondary"
            >
              ← Back
            </button>
          )}
          <button
            type="submit"
            disabled={saving}
            className="btn-primary"
          >
            {saving ? "Saving…" : isWizard ? "Next →" : "Save & Continue"}
          </button>
        </div>
      </form>
    </Layout>
  );
}